export const ACCOUNT_CONTEXT_INVALID_EVENT = "account-context-invalid";

const HAS_MULTIPLE_ACCOUNTS_KEY = "accountSelection.hasMultipleAccounts";
const SELECTED_ACCOUNT_KEY = "accountSelection.selectedAccountId";

function normalizeEmail(email) {
  return String(email || "").trim().toLowerCase();
}

function buildScopedKey(baseKey, email) {
  const normalizedEmail = normalizeEmail(email);
  return normalizedEmail ? `${baseKey}:${normalizedEmail}` : baseKey;
}

function safeGetItem(key) {
  try {
    if (typeof window === "undefined") return null;
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeSetItem(key, value) {
  try {
    if (typeof window === "undefined") return;
    window.localStorage.setItem(key, value);
  } catch {
    // Ignora ambientes sem localStorage ou armazenamento bloqueado.
  }
}

function safeRemoveItem(key) {
  try {
    if (typeof window === "undefined") return;
    window.localStorage.removeItem(key);
  } catch {
    // Ignora ambientes sem localStorage ou armazenamento bloqueado.
  }
}

export function getMultipleAccountsStorageKey(email) {
  return buildScopedKey(HAS_MULTIPLE_ACCOUNTS_KEY, email);
}

export function setHasMultipleAccounts(email, hasMultipleAccounts) {
  safeSetItem(
    getMultipleAccountsStorageKey(email),
    hasMultipleAccounts ? "true" : "false"
  );
}

export function getHasMultipleAccounts(email) {
  return safeGetItem(getMultipleAccountsStorageKey(email)) === "true";
}

export function getSelectedAccountStorageKey(email) {
  return buildScopedKey(SELECTED_ACCOUNT_KEY, email);
}

export function setSelectedAccountId(email, accountId) {
  const normalizedAccountId = String(accountId || "").trim();
  const key = getSelectedAccountStorageKey(email);

  if (!normalizedAccountId) {
    safeRemoveItem(key);
    return;
  }

  safeSetItem(key, normalizedAccountId);
}

export function getSelectedAccountId(email) {
  return safeGetItem(getSelectedAccountStorageKey(email));
}

export function clearSelectedAccountId(email) {
  safeRemoveItem(getSelectedAccountStorageKey(email));
}

export function clearAllAccountContext() {
  try {
    if (typeof window === "undefined") return;

    const keysToRemove = [];
    for (let index = 0; index < window.localStorage.length; index += 1) {
      const key = window.localStorage.key(index);
      if (
        key === HAS_MULTIPLE_ACCOUNTS_KEY ||
        key === SELECTED_ACCOUNT_KEY ||
        key?.startsWith(`${HAS_MULTIPLE_ACCOUNTS_KEY}:`) ||
        key?.startsWith(`${SELECTED_ACCOUNT_KEY}:`)
      ) {
        keysToRemove.push(key);
      }
    }

    keysToRemove.forEach((key) => window.localStorage.removeItem(key));
  } catch {
    // Ignora ambientes sem localStorage ou armazenamento bloqueado.
  }
}

export function notifyAccountContextInvalid(error) {
  if (typeof window === "undefined") return;

  window.dispatchEvent(
    new CustomEvent(ACCOUNT_CONTEXT_INVALID_EVENT, {
      detail: {
        code: error?.error || error?.code || "",
        message: error?.message || "",
        details: error?.details || null,
      },
    })
  );
}
